import React from 'react';
import PropTypes from 'prop-types';

import ProgressBar from '../ProgressBar';

import FavoritesStarIcon from '../Iconoclast/FavoritesStarIcon/index';
import taskIcon from '../../assets/images/task-icon-gray2.svg';
import attachmentIcon from '../../assets/images/attachment-icon-gray.svg';

import styles from '../../assets/styles/globals.scss';
import './DashboardProjectCard.scss';
import i18n from '../../i18n';

DashboardProjectCard.propTypes = {
  handleCardClick: PropTypes.func,
};

function formatDate(date) {
  let formattedDate = null;
  if (date) {
    let dateFormatter = new Date(date);
    let month = dateFormatter.getMonth() + 1;
    if (month < 10) {
      month = '0' + month;
    }
    let day = dateFormatter.getDate();
    if (day < 10) {
      day = '0' + day;
    }
    let year = dateFormatter.getFullYear();
    formattedDate = month + '/' + day + '/' + year;
  }
  return formattedDate;
}

export default function DashboardProjectCard(props) {
  const {
    project,
    projectTemplate,
    handleCardClick,
    handleRemoveFavorite,
    handleMakeFavorite,
    displayFavoriteSelector,
    displayDocuments,
    left,
    top,
    width,
    height,
  } = props;

  const projectCompletionPercentage = project && project.tasks_count ? (project.tasks_completed_count ? project.tasks_completed_count : 0) / project.tasks_count : 0;
  const progressBar = <ProgressBar percentage={projectCompletionPercentage * 100} />;
 
  // let offlineChangesIndicator = null
  // if (project && project.is_offline_project) {
  //   offlineChangesIndicator = <div className="project-offline-indicator"/>;
  // }

  let locationText = '';
  if (project && project.location) {
    let location = project.location;
    if (location) {
      locationText = location.city ? (location.city + ', ' + location.state) : location.state;
    }
  }

  let style = {};
  if (left != undefined && top != undefined) {
    style = { width: width ? width : 256, height: height ? height: 'auto', left: left, top: top, position: 'absolute' };
  }
  
  let pmText = `${i18n.tr('user_dashboard:project_manager_initials')} | `;
  if (project && project.project_manager) {
    let project_manager = project.project_manager;
    if (project_manager) {
      pmText += project_manager.first_name + ' ' + project_manager.last_name;
    } else {
      pmText += 'Not Available';
    }
  } else {
    pmText += 'None Assigned';
  }
 
  function handleFavorited(e) {
    if (project && project.is_favorite) {
      handleRemoveFavorite(e, project.id);
    } else {
      handleMakeFavorite(e, project.id);
    }
  }

  let isFavorite = project && project.is_favorite ? styles.inProgress : styles.warmGreyTwo;
  const reference_documents = project ? project.reference_documents : projectTemplate ? projectTemplate.reference_documents : null;
  const unique_documents = project && project.unique_documents;
  let projectStart = null;
  let projectCompletion = null;
  if (project && project.config && project.config.duration) {
    if (project.completed_at) {
      let completedDate = formatDate(project.completed_at);
  
      projectCompletion = <div className="project-date">{'Completed On: ' + completedDate}</div>;
    }
    else if (project.estimated_completion_date) {
      const completionDate = formatDate(project.estimated_completion_date);
  
      projectCompletion = <div className="project-date">{'Estimated Completion: ' + completionDate}</div>;
    }
    if (project.actual_start_date) {
      let actualStartDate = formatDate(project.actual_start_date);
  
      projectStart = <div className="project-date">{'Started On: ' + actualStartDate}</div>;
    }
    else if (project.projected_start_date) {
      let projectedStartDate = formatDate(project.projected_start_date);
  
      let pastDue = '';
      const testDate = new Date(project.projected_start_date);
      if (testDate.getTime() < new Date().getTime()) {
        pastDue = ' past-due';
      }
      projectStart = <div className={'project-date' + pastDue}>{'Projected Start: ' + projectedStartDate}</div>;
    }
  }

  return (
    <div key={'user-project-' + (project ? project.id : projectTemplate ? projectTemplate.id : null)} className="user-project" style={style} onClick={ () => handleCardClick(project || projectTemplate) }>
      <div className="user-project__contents-container">
        {project && <div className="location">{locationText}</div>}
        <div className="project-name">{project ? project.name : projectTemplate ? projectTemplate.name : ''}</div>
        {project && <div className="pm-text">{pmText}</div>}
        {displayFavoriteSelector && <div className="favorite favorite-icon" onClick={(e) => handleFavorited(e)}>
          <FavoritesStarIcon fillColor={isFavorite} />
        </div>}
        {progressBar}
        {/* {displayFavoriteSelector && offlineChangesIndicator} */}
        {displayFavoriteSelector}
        {projectStart}
        { projectCompletion}
        {displayDocuments &&
        <div className="project__info">
        <div className="detailed-info">
          <img className="task-icon" src={taskIcon} alt="tasks"/>
          <div className="task-counts">{'Tasks | ' + (projectTemplate ? projectTemplate.tasks_count : project ? (project.tasks_completed_count + '/' + project.tasks_count) : '')}</div>
        </div>
          {reference_documents &&
            <div className="detailed-info">
              <img alt="reference" className="document-icon" src={attachmentIcon} />
              <div className="document-title">Reference Documents</div>
              <div className="document-count">{'| ' + reference_documents.length}</div>
            </div>}
          {unique_documents &&
            <div className="detailed-info">
              <img alt="unique" className="document-icon" src={attachmentIcon} />
              <div className="document-title">Project Documents</div>
              <div className="document-count">{'| ' + unique_documents.length}</div>
            </div>}
        </div>
      }
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/DashboardProjectCard/index.js